'use client'
import Link from 'next/link';
import { twMerge } from 'tailwind-merge';
import { ILocalizedParams } from '../../../models/ICommon';
import Image from 'next/image';
import { IGeneralSettings } from '../../../models/IGeneralSettings';
import { IMenuItem } from '../../../models/IMenuItem';

import { appConfig } from '../../../config';
import GooglePlay from '../svg/GooglePlay';
import AppStore from '../svg/AppStore';
import dynamic from 'next/dynamic';
import Loader from '../svg/Loader';
import NewsButton from './NewsButton';

const EremSocials = dynamic(() => import('../EremSocials'), {loading: () => <div/>});

export default function Footer({locale, settings, staticPages, menu}: ILocalizedParams<{settings: IGeneralSettings; staticPages: {
    id: number;
    title: string;
    description: string;
    body: string;
    slug: string;
    type: number;
}[]; menu: IMenuItem[]}>
) {


  return (
    <>
       <div className='flex desktop:hidden flex-col w-full bg-tertiary dark:bg-quaternary' data-nosnippet>
      <div className='flex flex-col items-center justify-center tablet:justify-between w-full py-[36px] tablet:py-[12px] px-[24px] gap-[36px] bg-[rgba(255,255,255,0.12)] tablet:flex-row'>
        <div className='flex flex-col gap-[6px] items-center tablet:items-start'>

            <a hrefLang={locale} title={'logo'} href={`/`} className={twMerge('w-[161px] h-[48px] flex-shrink-0')}>
                {settings.publisherSettings.logoDarkmode ? <img src={settings.publisherSettings.logoDarkmode!} alt='logo' fetchPriority='low' className={twMerge('absolute top-0 left-0 h-full w-full')} /> : null}
            </a>
            {settings.publisherSettings.description ? <span className='text-white sm'>{settings.publisherSettings.description}</span> : null}
        </div>
            <div className='flex flex-col tablet:flex-col-reverse gap-[36px] tablet:gap-[12px]'>

         <EremSocials settings={settings} dark className='gap-x-[24px]' expandable={false}/>
            <NewsButton/>
            </div>

      </div>

      <div className='flex flex-col w-full bg-transparent py-[48px] px-[24px]'>
             <div className='flex items-center justify-center tablet:justify-start w-full gap-[24px] [&>*]:cursor-pointer mb-[36px] [&>*]:flex-1 max-w-full tablet:[&>*]:flex-[unset] [&>*]:flex-shrink'>
            <Link target='_blank' href={appConfig.appStoreUrl}>
            <AppStore className='!w-full'/>
            </Link>
            <Link target='_blank' href={appConfig.googlePlayUrl}>
            <GooglePlay className='!w-full'/>
            </Link>
          </div>
        <ul className='grid grid-cols-3 tablet:grid-cols-4 w-full gap-x-[24px] gap-y-[16px] mb-[36px]'>
          {menu.map(x => (
            <li key={x.id} className='list-none'><Link prefetch={false} href={`/${x.destination}`} ><h5 className='text-white h6 !text-[16px] font-medium whitespace-normal line-clamp-1 truncate'>{x.title}</h5></Link></li>
          ))}
        </ul>
     
          <div className='flex w-full mb-[24px] flex-wrap gap-y-[16px]'>
            {staticPages.map((x,i) => (
              <div className='flex items-center' key={x.slug}>
              <Link  href={`/${x.slug}`} title={x.title!} key={x.id}><span className='whitespace-nowrap text-white h6 !text-[16px]'>{x.title}</span></Link>
                {i >= staticPages.length - 1 ?  null : <div className='text-white mx-[8px]'>|</div>}
              </div>
            ))}
          </div>
            {settings.publisherSettings.copyright ? <div className='h6 text-white tablet:text-start text-center w-full' dangerouslySetInnerHTML={{__html: settings.publisherSettings.copyright}}/> : <div/>}
      

      </div>
    </div>

    <div className='hidden desktop:flex flex-col w-full bg-tertiary dark:bg-quaternary' data-nosnippet>
      <div className='flex items-center justify-between w-full h-[104px] bg-[rgba(255,255,255,0.12)]'>
        <div className='w-full max-w-[1296px] mx-auto flex items-center justify-between desktopSm:px-[24px]'>
          <div className='flex flex-col gap-[6px]'>

            <a hrefLang={locale} title={'logo'} href={`/`} className={twMerge('w-[161px] h-[48px] flex-shrink-0')}>
                {settings.publisherSettings.logoDarkmode ? <img src={settings.publisherSettings.logoDarkmode!} alt='logo' fetchPriority='low' className={twMerge('absolute top-0 left-0 h-full w-full')} /> : null}
            </a>
            {settings.publisherSettings.description ? <span className='text-white sm'>{settings.publisherSettings.description}</span> : null}
          </div>
            <div className='flex items-center gap-[24px]'>
              <NewsButton />

         <EremSocials dark settings={settings} expandable={false} className='gap-x-[24px]'/>
            </div>

        </div>
      </div>

      <div className='flex flex-col max-w-[1296px] w-full mx-auto bg-transparent py-[48px] desktopSm:px-[24px]'>

        <div className='w-full flex items-start justify-between gap-[24px] mb-[24px]'>
           <ul className='grid grid-cols-5 w-full gap-x-[48px] gap-y-[16px]'>
          {menu.map(x => (
            <li key={x.id} className='list-none'><Link prefetch={false} href={`/${x.destination}`}><h5 className='text-white md font-medium'>{x.title}</h5></Link></li>
          ))}
        </ul>
           <div className='flex items-center justify-center gap-[24px] [&>*]:cursor-pointer'>
            <Link target='_blank' href={appConfig.appStoreUrl}>
            <AppStore/>
            </Link>
            <Link target='_blank' href={appConfig.googlePlayUrl}>
            <GooglePlay/>
            </Link>
          </div>
        </div>
       
       
          <div className='flex w-full mb-[12px] flex-wrap gap-y-[16px]'>
            {staticPages.map((x,i) => (
              <div className='flex items-center' key={x.slug}>

              <Link  href={`/${x.slug}`} title={x.title!} key={x.id}><span className='whitespace-nowrap text-white md font-medium'>{x.title}</span></Link>
              {i >= staticPages.length - 1 ?  null : <div className='text-white mx-[12px]'>|</div>}
              </div>
            ))}
          </div>
            {settings.publisherSettings.copyright ? <div className='md font-medium text-white' dangerouslySetInnerHTML={{__html: settings.publisherSettings.copyright}}/> : <div/>}
      

      </div>
    </div>
    </>
  )
}